import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { CollapsibleSection } from "./CollapsibleSection";

interface IBrandMentionsSectionProps {
    brands: string[];
}

export const BrandMentionsSection: FC<IBrandMentionsSectionProps> = ({ brands }) => {
    if (!brands || brands.length === 0) {
        return null;
    }

    return (
        <CollapsibleSection
            title={translate("llm.prompts.citations_side_panel.brand_mentions.title")}
            defaultExpanded={false}
            margin="16px 0 0 0"
        >
            <Flex
                padding="24px 16px"
                borderRadius="4px"
                border={`1px solid ${colorsPalettes.carbon[50]}`}
            >
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[500]}
                >
                    {brands.join(", ")}
                </Text>
            </Flex>
        </CollapsibleSection>
    );
};
